import $ from 'jquery';
import { deleteFormatBackground } from '../backgroundFormats/deleteFormatBackground';

export const onClickDeleteBackgroundFormat = (event) => {
  const sidebarCurrentBackgroundFormatItemId = $(event.currentTarget).data(
    'delete-background-id'
  );
  const sidebarCurrentFormatItemId = $(event.currentTarget).data(
    'delete-background-format-id'
  );
  const sidebarCurrentFormatStatus = $(event.currentTarget).data(
    'delete-background-format-status'
  );
  deleteFormatBackground(
    sidebarCurrentBackgroundFormatItemId,
    sidebarCurrentFormatItemId,
    sidebarCurrentFormatStatus
  );
};
